import React from 'react';
import { useState } from 'react'
import {FaBars, FaTimes} from 'react-icons/fa'
import {Link} from 'react-router-dom'
import logo from '../assets/logo.png'
import { navItems, finanseDropdown } from './Navitems';
import Dropdown from './Dropdown';


function Navbar() {

  const [nav, setNav] = useState(false)

  const handleNav = () => {
          setNav(!nav)
  }

   const [dropdown, setDropdown] = useState(false);

  return (
    <div className='fixed w-full !z-50'>
      <div className='bg-white shadow-md'>
      <nav className='h-24 flex justify-between items-center max-w-[1040px] mx-auto text-md'>
        <Link to='/'>
            <img src={logo} alt='logo' className='object-scale-down h-24'/>
        </Link>
        <ul className='hidden md:flex text-center '>
            {navItems.map((item) => {
               if(item.title === 'Finanse') {
                 return(
                  <li key={item.id} className='px-6 hover:scale-105 duration-500 hover:text-black'  
                  onMouseEnter={() => setDropdown(true)} 
                  onMouseLeave={() => setDropdown(false)}>

                  <Link to={item.path}>{item.title}</Link>

                  {dropdown && <Dropdown />}
                  </li>
                 )
               }

              return(
               <li key={item.id} className='px-8 hover:scale-105 duration-500'>
               <Link to={item.path}>{item.title}</Link>
               </li>
              )
            })}
            <li className='px-6 hover:scale-105 duration-500'>
              <a href="https://www.facebook.com/profile.php?id=100086489706249" target="_blank">Facebook</a>
            </li>
        </ul>
          <div onClick={handleNav} className='block md:hidden pr-6'>
            {nav ? <FaTimes size={20}/> : <FaBars size={20}/>}
          </div>
      </nav>

      <div className={nav ? 'fixed bg-white w-full h-screen' : 'hidden'}>
        <ul className='text-center'>
            
            {finanseDropdown.map((item) => (
              <li key={item.id} className='pt-8 text-2xl font-semibold'>
                <Link to={item.path} className='bg-slate-100 px-5 py-2 rounded-xl'>{item.title}</Link>
              </li>
            ))}
            {navItems.map((item) => {
              if(item.title != 'Finanse'){
                return(
                <li key={item.id} className='pt-8 text-2xl font-semibold'>
                <Link to={item.path} className='bg-slate-100 px-5 py-2 rounded-xl'>{item.title}</Link>
                </li>
                )
              }
             })}
        </ul>
      </div>
      
     </div>
    </div>
  )
}

export default Navbar